module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "product-card"
  }, [_c('v-flex', {
    staticClass: "product-info"
  }, [_c('v-flex', {
    staticClass: "product-cover",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "product-image",
    style: ({
      'background-image': 'url(' + _vm.product.covers[0].cover.url + ')'
    })
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "product-actions",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    }
  }), _vm._v(" "), (this.$store.state.auth.user.id === _vm.product.merchant.id && _vm.editButtonAction) ? _c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.editButtonAction(_vm.product)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-2": ""
    }
  }, [(_vm.product.collaborators_count === 0) ? [(_vm.deleteButtonAction) ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteButtonAction(_vm.product)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), (_vm.updateButtonAction) ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateButtonAction(_vm.product)
      }
    }
  }, [_vm._v(_vm._s(_vm.updateButtonText))]) : _vm._e()] : [(_vm.product.status == 'pending') ? _c('div', {
    staticClass: "collaboration-status"
  }, [(_vm.product.merchant.id === this.$store.state.auth.user.id && _vm.usersCountByStatus.accepted === _vm.product.collaborators_count) ? [_c('div', {
    staticClass: "approve-wrapper"
  }, [_c('div', {
    staticClass: "approved-text"
  }, [_vm._v("This product has been "), _c('br'), _c('span', [_vm._v("APPROVED")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "action-btn release",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.releaseButtonAction(_vm.product)
      }
    }
  }, [_vm._v("Release Now")])], 1)] : _c('div', {
    staticClass: "status-overview"
  }, [(_vm.usersCountByStatus.accepted > 0) ? _c('div', [_c('div', {
    staticClass: "accepted-title"
  }, [_vm._v("Accepted")]), _vm._v(" "), _vm._l((_vm.usersByStatus.accepted), function(c) {
    return _c('div', [_vm._v(_vm._s(c.user.username))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.usersCountByStatus.denied > 0) ? _c('div', [_c('div', {
    staticClass: "denied-title"
  }, [_vm._v("Denied")]), _vm._v(" "), _vm._l((_vm.usersByStatus.denied), function(c) {
    return _c('div', [_vm._v(_vm._s(c.user.username))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.usersCountByStatus.pending > 0) ? _c('div', [_c('div', {
    staticClass: "pending-title"
  }, [_vm._v("Waiting for approval")]), _vm._v(" "), _vm._l((_vm.usersByStatus.pending), function(c) {
    return _c('div', [_vm._v(_vm._s(c.user.username))])
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.acceptButtonAction) ? _c('div', {
    staticClass: "collaboration-actions"
  }, [_c('v-btn', {
    staticClass: "action-btn accept",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.acceptButtonAction(_vm.product)
      }
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('v-btn', {
    staticClass: "action-btn deny",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.denyButtonAction(_vm.product)
      }
    }
  }, [_vm._v("Deny")])], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.deleteButtonAction && this.$store.state.auth.user.id === _vm.product.merchant.id) ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteButtonAction(_vm.product)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), (_vm.product.status == 'collaborated') ? _c('div', {
    staticClass: "collaboration-status"
  }, [_c('div', {
    staticClass: "status-overview"
  }, [_c('div', [_c('div', {
    staticClass: "accepted-title"
  }, [_vm._v("Collaborators")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.product.merchant.username) + " (owner) - " + _vm._s(_vm.ownerShare) + "%")]), _vm._v(" "), _vm._l((_vm.usersByStatus.accepted), function(c) {
    return _c('div', [_vm._v(_vm._s(c.user.username) + " - " + _vm._s(c.user_share) + "%")])
  })], 2)])]) : _vm._e()]], 2), _vm._v(" "), _c('p', {
    staticClass: "product-count"
  }, [_vm._v(_vm._s(_vm.product.stock) + " in stock")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "product-detail"
  }, [_c('p', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _c('p', {
    staticClass: "product-user-name"
  }, [_vm._v(_vm._s(_vm.product.merchant.username))])])], 1), _vm._v(" "), (_vm.isShowPromoteModal) ? _c('promote-modal', {
    attrs: {
      "item": _vm.product,
      "dismiss": _vm.dismissPromoteDialog,
      "success": _vm.saveAndFinish
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a51e90ca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sell/components/collaborate_product.vue
// module id = 1830
// module chunks = 180